import styled from 'styled-components';
import {getRatingsColor} from '@stencil/hotels-utils/src/get-ratings-colors';
import Image from '@stencil/image';
import {BaseColumnWrap} from '../../../../CommonStyleUtils/dwebCommon.styles';
import {headingSizes, textSizes} from '@stencil/build-theme';

export const AutocompleteWrapperStyles = styled(BaseColumnWrap)`
  ${props =>
    !props.isHomePageRevamp &&
    `position: relative;
  margin-left:${props.theme.spacing.custom(7)}`}
`;

export const SearchInputStyles = styled.input`
  display: inline-flex;
  width: 90%;
  border: none;
  height: 2.5rem;
  ${textSizes.LargeW2}
  ::placeholder {
    color: ${props => props.theme.colors.downriver.medium};
    opacity: 1; /* Firefox */
    ${textSizes.LargeW2}
    height:2.5rem;
  }

  &:focus {
    box-shadow: none;
    outline-offset: 0;
    outline: 0;
  }
`;

export const SearchListItem = styled.li`
  ${textSizes.MediumW1}
  display: flex;
  align-items: center;
  border-top: 1px solid ${props => props.theme.colors.downriver.light};
  padding: ${props => props.theme.spacing.large};
  background: ${props =>
    props.$isActive ? props.theme.colors.downriver.light : props.theme.colors.goWhite.base};
  &:first-child {
    border-top: none;
  }
`;

export const SearchMenuStyles = styled.ul(
  props => `
  z-index: ${props.theme.misc.zIndex.xxlarge};
  position: absolute;
  top: ${props.top || '4rem'};
  left: ${props.left || '-2rem'};
  /* left: ${-props.theme.spacing.xlarge}; */
  list-style-type: none;
  background: ${props.theme.colors.goWhite.base};
  border-radius: 4px;
  box-shadow: ${props.boxShadow ? props.boxShadow : `0 2px 14px 0 rgba(0, 0, 0, 0.16)`};
  transform: translateY(4px);
  min-width:${props.minWidth ? props.minWidth : '54rem'};  /** zepline has 746px, change to it if need*/
  max-height: ${props.maxHeight ? props.maxHeight : '90vh'};
  overflow-y: auto;
  ${SearchListItem} :first-of-type {
    border-top: none;
  }

  &::-webkit-scrollbar {
    -webkit-appearance: none;
    width: 7px;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background-color: ${props.theme.colors.downriver.medium};
    box-shadow: 0 0 1px ${props.theme.colors.downriver.light};
  }
`,
);

export const SearchHotelNumber = styled.p(
  props => `
  position: relative;
  color:${props.theme.colors.downriver.medium};
  font-size:${props.theme.font.custom(14)};
  font-weight:normal;
  margin-top:${props.theme.spacing.small};
  `,
);

export const SearchListItemLocationName = styled.span`
  flex: 5;
`;

export const SearchListItemLocationType = styled.div`
  flex: 2;
  text-align: right;
  font-weight: 600;
  text-transform: capitalize;
  /* these are needed so that <Text /> span inside rating div takes full height of its parent ( the div )*/
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`;

export const ErrorMessage = styled.div(
  props => `
  color: ${props.theme.colors.goRed.base};
  font-size: ${props.theme.font.custom(14)};
  padding: ${props.theme.spacing.xsmall};
  font-weight:normal;
  position: absolute;
  right: 0;
`,
);

export const StyledIcon = styled.div(
  props => `
  height: ${props.theme.spacing.custom(24)};
  fill:${props.theme.colors.downriver.medium};
  width: ${props.theme.spacing.custom(24)};
  margin: 0 ${props.theme.spacing.custom(13)} 0 0;
`,
);

export const SearchLabelStyles = styled.label(
  props => `
  color: ${props.theme.colors.goWhite.base};
  padding-bottom: ${props.theme.spacing.small};
  padding-left: ${props.theme.spacing.custom(2)};
`,
);

export const RatingStyles = styled.span(props => {
  return `
  color: ${props.theme.colors.goWhite.base};
  background: ${getRatingsColor(props.rating)};
  border-radius: 2px;
  padding: ${props.theme.spacing.custom(3)} ${props.theme.spacing.small};
  display: flex;
  width: fit-content;
`;
});

export const TripadvisorImageStyles = styled(Image)`
  max-width: 3rem;
  padding-right: 0.4rem;
`;

// Region css

export const AutoSuggestItem = styled.li(
  props => `
  display:flex;
  justify-content:space-between;
  align-items:end;
  width:100%;
  max-width:537px;
  // height:371px;
  overflow:auto;
  background: ${props.theme.colors.goWhite.base};

  border-radius: ${props.theme.misc.borderRadius.custom(2)};
  margin-bottom: ${props.theme.spacing.custom(1)};
  border-top: 1px solid #C2C2C2;

  ${AutosuggestLocationDiv} {
    background: ${
      // @ts-ignore
      props.isActive ? props.theme.colors.downriver.light : props.theme.colors.goWhite.base
    };
  }
  `,
);

export const AutosuggestLocationDiv = styled.div(
  props => `
  display:flex;
  flex-direction:row;
  justify-content:space-between;
  padding: ${props.theme.spacing.custom(12)} ${props.theme.spacing.custom(
    12,
  )} 0 ${props.theme.spacing.custom(12)};
  `,
);

export const NearByLocationImg = styled(Image)(
  props => `
  width: 2rem;
  height: 2.5rem;
  margin-right:${props.theme.spacing.base};

  `,
);

export const SuggestionWrapperDiv = styled.div(
  props => `
  width:89%;
  padding-bottom: 1rem;
  `,
);

export const LoctionName = styled.div`
  ${textSizes.MediumW3}
  color: ${props => props.theme.colors.downriver.base};
  &.disabled {
    color: ${props => props.theme.colors.downriver.light};
  }
`;

export const NumberofPropertySpan = styled.span(
  props => `
    color: ${props.theme.colors.goBrandBlue.base};
  `,
);

export const AutoSuggestRightWrap = styled.div(
  props => `
  text-align:right;
  `,
);

export const LocationTypeWrapper = styled.div(
  props => `
  font-size: ${props.theme.font.custom(12)};
  color:${props.theme.colors.ash.base};
  text-transform: capitalize;
  padding-right: 1.1rem;
  &.disabled{
    color: ${props.theme.colors.downriver.light};
  }
  `,
);

export const AutoSuggestLocationNewItems = styled.ul(
  props => `
  display: flex;
  flex-direction:column;
  padding-left:${props.theme.spacing.base};
  padding: 0 ${props.theme.spacing.custom(11)} 0 ${props.theme.spacing.custom(22)};
    `,
);

export const AutoSuggestChildItem = styled.li(
  props => `

    border-left:1px solid ${props.theme.colors.ash.dark};
    background: ${
      props.isActive ? props.theme.colors.downriver.light : props.theme.colors.goWhite.base
    };
    &:last-child{
      height: 2.9rem;
      margin-bottom: ${props.theme.spacing.custom(25)};
      }

    ${AutoSuggestChildItemInner} {
      background: ${
        props.isActive ? props.theme.colors.downriver.light : props.theme.colors.goWhite.base
      };
    }
    `,
);

export const AutoSuggestChildItemInner = styled.div(
  props => `

    height: 5.2rem;
    display:flex;
    `,
);

export const LineDiv = styled.div(
  props => `
  width:4%;
  height:1px;
  background:${props.theme.colors.ash.dark};
  position:relative;
  bottom:-2.8rem;
  margin-right: ${props.theme.spacing.small};

  `,
);

export const CityNameDiv = styled.div(
  props => `
  font-size: ${props.theme.font.custom(16)};
  `,
);

export const PropertyDetailsNameDiv = styled.div(
  props => `
    color: ${props.theme.colors.ash.base};
    padding-bottom: ${props.theme.font.custom(8)};
  `,
);

export const PropertyNameOuterWrapper = styled(BaseColumnWrap)(
  props => `
  padding-top: ${props.theme.font.custom(10)};
  `,
);

export const PersuationWrapperWrapperDiv = styled.div(
  props => `
  display:flex;
  width:fit-content;
  background: ${props.theme.colors.goGreen.light};
  border-radius: ${props.theme.misc.borderRadius.custom(20)};
  padding:${props.theme.spacing.custom(3)} ${props.theme.spacing.custom(6)};
  font-size: ${props.theme.font.custom(9)};
  color:${props.theme.colors.goGreen.dark};
  font-weight: 600;
  margin-top:${props.theme.spacing.xsmall};
  align-items:center;
  `,
);

export const FswAutoCompHeader = styled.div`
  padding: 29px 24px 16px 24px;
  position: relative;
  > input {
    width: 100%;
    background: #ffffff;
    border: 2px solid #2276e3;
    border-radius: 8px;
    outline: 0;
    ${headingSizes.Small};
    color: #141823;
    padding: 20px 18px;
  }
  ${p =>
    p.isDestination &&
    `
    input{
      padding: 20px 18px 20px 28px;
    } 
  `}
`;

export const FswAutoCompLegend = styled.span`
  ${textSizes.BaseW2};
  color: #2276e3;
  display: inline-flex;
  padding: 0 4px;
  background-color: #fff;
  position: absolute;
  left: 40px;
  top: 21px;
  ${p =>
    p.isDestination &&
    `
    left: 50px;  
  `}
`;

export const FswAutoCompBody = styled.div`
  border-top: 1px solid #f2f2f2;
  margin-right: 10px;
  > ul {
    position: relative !important;
    top: 0 !important;
    left: 0 !important;
    min-width: fit-content !important;
  }
  // max-height: 400px;
  // overflow-y: auto;
`;

export const FswAutoCompItemOuter = styled.li`
  padding: 16px 24px;
  margin: 0 4px;
  border-bottom: 1px solid #e4e4e4;
  cursor: pointer;
  list-style: none;

  :last-child {
    border-bottom: none;
  }
`;
export const FswAutoCompItemLeft = styled.div`
  flex: 1;
  display: flex;
`;

export const FswAutoCompItem = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const FswAutoCompItemImg = styled.span`
  width: 24px;
  flex-shrink: 0;
  margin-right: 12px;
`;
export const FswAutoCompItemDesc = styled.div`
  flex: 1;
`;

export const FswAutoCompItemDescWrapper = styled.div`
  /* flex: 1; */
`;
export const FswAutoCompItemDescTitle = styled.p`
  ${textSizes.MediumW1};
  color: #222;
  margin-bottom: 2px;
  span {
    font-weight: 500;
  }
`;
export const FswAutoCompItemDescSubTitle = styled.p`
  ${textSizes.SmallW1};
  color: #717171;
`;

export const FswAutoCompItemDescSubTitleLink = styled.a`
  ${textSizes.SmallW1};
  color: #2276e3;
  display: block;
`;
export const FswAutoCompItemRight = styled.div`
  flex-shrink: 0;
  margin-left: 20px;
  display: flex;
`;

export const FswAutoCompItemCity = styled.span`
  ${textSizes.SmallW2};
  color: #717171;
  margin-right: 12px;

  &.regularText {
    font-weight: 400;
  }
`;

export const FswAutoCompItemFlag = styled.span`
  width: 32px;
  vertical-align: top;
`;

export const PopularSearchesHeading = styled.p`
  ${headingSizes.Small};
  margin-bottom: 14px;
`;
